import React from 'react';
import Layout from '../../layout/Layout';
import './MenuPricing.css';

const MenuPricing = () => {
  const handleBarClick = () => {
    // Navigate to Bar management
    window.location.href = '/menu/bar-management';
  };

  const handleFoodClick = () => {
    // Navigate to Food management
    window.location.href = '/menu/food-management';
  };

  return (
    <Layout>
      <div className="menupricing-container">
        <div className="content-header">
          <h2> Menu Pricing Management</h2>
          <p className="content-description">Manage pricing for your menu items</p>
        </div>

        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12">
            <div className="pricing-card bar-card" onClick={handleBarClick}>
              <div className="card-icon">
                <i className="zmdi zmdi-cocktail"></i>
              </div>
              <div className="card-content">
                <h3>Bar Items</h3>
                <p>Manage pricing for beverages, cocktails, and bar items</p>
                <div className="card-stats">
                  <div className="stat-item">
                    <span className="stat-number">45</span>
                    <span className="stat-label">Total Items</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-number">12</span>
                    <span className="stat-label">Categories</span>
                  </div>
                </div>
              </div>
              <div className="card-arrow">
                <i className="zmdi zmdi-chevron-right"></i>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-12">
            <div className="pricing-card food-card" onClick={handleFoodClick}>
              <div className="card-icon">
                <i className="zmdi zmdi-pizza"></i>
              </div>
              <div className="card-content">
                <h3>Food Items</h3>
                <p>Manage pricing for dishes, appetizers, and food items</p>
                <div className="card-stats">
                  <div className="stat-item">
                    <span className="stat-number">128</span>
                    <span className="stat-label">Total Items</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-number">8</span>
                    <span className="stat-label">Categories</span>
                  </div>
                </div>
              </div>
              <div className="card-arrow">
                <i className="zmdi zmdi-chevron-right"></i>
              </div>
            </div>
          </div>
        </div>

        {/* Quick Stats Section */}
        <div className="row mt-4">
          <div className="col-12">
            <div className="quick-stats-card">
              <h4><i className="zmdi zmdi-chart mr-2"></i>Quick Statistics</h4>
              <div className="stats-grid">
                <div className="stat-box">
                  <div className="stat-icon">
                    <i className="zmdi zmdi-trending-up text-success"></i>
                  </div>
                  <div className="stat-details">
                    <h5>₿15,420</h5>
                    <p>Average Daily Revenue</p>
                  </div>
                </div>
                <div className="stat-box">
                  <div className="stat-icon">
                    <i className="zmdi zmdi-star text-warning"></i>
                  </div>
                  <div className="stat-details">
                    <h5>89%</h5>
                    <p>Customer Satisfaction</p>
                  </div>
                </div>
                <div className="stat-box">
                  <div className="stat-icon">
                    <i className="zmdi zmdi-time text-info"></i>
                  </div>
                  <div className="stat-details">
                    <h5>12 min</h5>
                    <p>Average Prep Time</p>
                  </div>
                </div>
                <div className="stat-box">
                  <div className="stat-icon">
                    <i className="zmdi zmdi-shopping-cart text-primary"></i>
                  </div>
                  <div className="stat-details">
                    <h5>173</h5>
                    <p>Total Menu Items</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Recent Activity Section */}
        <div className="row mt-4">
          <div className="col-12">
            <div className="recent-activity-card">
              <h4><i className="zmdi zmdi-time-restore mr-2"></i>Recent Price Updates</h4>
              <div className="activity-list">
                <div className="activity-item">
                  <div className="activity-icon">
                    <i className="zmdi zmdi-cocktail text-primary"></i>
                  </div>
                  <div className="activity-content">
                    <h6>Mojito Classic</h6>
                    <p>Price updated from ₿180 to ₿200</p>
                    <small className="text-muted">2 hours ago</small>
                  </div>
                  <div className="activity-status">
                    <span className="badge badge-success">Updated</span>
                  </div>
                </div>
                <div className="activity-item">
                  <div className="activity-icon">
                    <i className="zmdi zmdi-pizza text-warning"></i>
                  </div>
                  <div className="activity-content">
                    <h6>Chicken Thai Curry</h6>
                    <p>Price updated from ₿320 to ₿350</p>
                    <small className="text-muted">5 hours ago</small>
                  </div>
                  <div className="activity-status">
                    <span className="badge badge-success">Updated</span>
                  </div>
                </div>
                <div className="activity-item">
                  <div className="activity-icon">
                    <i className="zmdi zmdi-wine text-danger"></i>
                  </div>
                  <div className="activity-content">
                    <h6>House Wine Red</h6>
                    <p>Price updated from ₿450 to ₿420</p>
                    <small className="text-muted">1 day ago</small>
                  </div>
                  <div className="activity-status">
                    <span className="badge badge-success">Updated</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default MenuPricing;
